// お客様の声一覧 (/pages/shop-reviews).
// markup design (2 cột + card icon-left), numbered pagination.
// Chờ ink:api:ready → GET /shop-reviews (summary + cards paginate). Star ★ inline. Fail-open.
(function () {
  'use strict';

  const PER_PAGE = 10;
  const ICONS = window.INK_REVIEW_ICONS || {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  // ★ cam design (#ff8a1c) có NỬA SAO — band + markup dùng chung
  // `assets/review-stars.js` (bản song sinh snippet `review-star-band` /
  // getSummaryStar ps_reviewCnet.php:219-245).
  function starsHtml(value) {
    return window.inkReviewStars ? window.inkReviewStars.html(value) : '';
  }

  function fmtDate(ts) {
    const d = new Date(Number(ts) * 1000);
    if (isNaN(d.getTime())) return '';
    return `${d.getMonth() + 1}月${d.getDate()}日`;
  }

  // Card design: icon + 属性 ở cột trái 120px; rating/title/body/購入商品 ở cột phải.
  function cardHtml(r) {
    const icon = ICONS[String(r.icon)] || ICONS['0'] || '';
    const meta = `${esc(r.pref_name) || '—'}のお客様<br>投稿日: ${fmtDate(r.cdate)}<br>${esc(r.order_count)}`;
    const img = r.review_image ? `<div class="mt-3"><img src="${esc(r.review_image)}" loading="lazy" class="max-w-[200px] max-h-[200px] rounded border" alt="レビュー画像"></div>` : '';
    const pur = r.purchased_product
      ? `<div class="mt-3 grid gap-2 rounded bg-slate-50 p-3 text-sm leading-6 lg:grid-cols-[110px_minmax(0,1fr)]"><span class="font-bold text-gray-800">購入商品</span><span class="ik-anywhere">${r.purchased_product.url ? `<a class="text-ink-blue" href="${esc(r.purchased_product.url)}">${esc(r.purchased_product.name)}</a>` : esc(r.purchased_product.name)}${r.purchased_product.other_count > 0 ? ` <span class="text-gray-500">他${r.purchased_product.other_count}点</span>` : ''}</span></div>`
      : '';
    return `
      <li class="rounded border border-ink-grayLine bg-white p-5 shadow-soft">
        <div class="grid gap-4 lg:grid-cols-[120px_minmax(0,1fr)]">
          <div class="text-center">
            <img class="mx-auto h-14 w-14 object-contain" src="${esc(icon)}" width="56" height="56" alt="お客様アイコン">
            <p class="mt-2 text-xs font-bold leading-5 text-gray-700">${meta}</p>
          </div>
          <div>
            <div class="flex flex-wrap items-center gap-2">
              <span class="text-lg font-bold text-ink-orange">${starsHtml(r.summary)}</span>
              <span class="text-lg font-bold text-ink-red">${Number(r.summary).toFixed(1)}</span>
            </div>
            <h3 class="mt-2 text-xl font-bold">${esc(r.review_title)}</h3>
            <p class="mt-3 whitespace-pre-line border-t border-ink-grayLine pt-3 leading-7">${esc(r.review_body)}</p>
            ${img}
            ${pur}
          </div>
        </div>
      </li>`;
  }

  function boot() {
    const root = document.querySelector('[data-shop-review-list]');
    if (!root) return;
    const itemsEl = root.querySelector('[data-review-items]');
    const pager = root.querySelector('[data-pager]');
    const resultInfo = root.querySelector('[data-result-info]');
    let page = 1;
    let lastPage = 1;

    function renderSummary(s) {
      root.querySelector('[data-summary-skeleton]')?.remove();
      const c = root.querySelector('[data-summary-content]');
      if (!s || !c) return;
      c.classList.remove('hidden');
      root.querySelector('[data-summary-avg]').textContent = Number(s.avg_rating).toFixed(1);
      root.querySelector('[data-summary-stars]').innerHTML = starsHtml(s.avg_rating);
      root.querySelector('[data-summary-count]').textContent = (s.count || 0).toLocaleString('ja-JP');
    }

    // Numbered pagination theo design (1 2 3 … 次へ » 最後 »»).
    function renderPager() {
      if (lastPage <= 1) { pager.classList.add('hidden'); pager.innerHTML = ''; return; }
      pager.classList.remove('hidden');
      const cell = (p, label, active) => active
        ? `<span class="inline-flex min-h-9 min-w-9 items-center justify-center rounded bg-ink-orange px-3 text-white">${label}</span>`
        : `<a href="#" data-page="${p}" class="inline-flex min-h-9 min-w-9 items-center justify-center rounded border border-ink-grayLine bg-white px-3">${label}</a>`;
      const win = [];
      for (let p = 1; p <= lastPage; p++) {
        if (p === 1 || p === lastPage || (p >= page - 2 && p <= page + 2)) win.push(p);
      }
      const parts = [];
      let prev = 0;
      win.forEach((p) => {
        if (p - prev > 1) parts.push('<span class="px-1 text-gray-500">…</span>');
        parts.push(cell(p, String(p), p === page));
        prev = p;
      });
      if (page < lastPage) {
        parts.push(`<a href="#" data-page="${page + 1}" class="inline-flex min-h-9 items-center justify-center rounded border border-ink-grayLine bg-white px-3">次へ »</a>`);
        parts.push(`<a href="#" data-page="${lastPage}" class="inline-flex min-h-9 items-center justify-center rounded border border-ink-grayLine bg-white px-3">最後 »»</a>`);
      }
      pager.innerHTML = parts.join('');
    }

    async function load() {
      let j;
      try { j = await window.inkApi.get('/shop-reviews', { page, per_page: PER_PAGE }); }
      catch (e) {
        console.warn('shop-reviews load fail', e);
        itemsEl.innerHTML = '<li class="text-center text-gray-500 py-6">読み込みに失敗しました。</li>';
        root.querySelector('[data-summary-skeleton]')?.remove();
        return;
      }

      renderSummary(j && j.summary);
      const data = (j && j.data) || {};
      const items = data.data || [];
      lastPage = data.last_page || 1;
      const total = data.total || 0;
      if (resultInfo) {
        if (total > 0) {
          const from = (page - 1) * PER_PAGE + 1;
          const to = Math.min(page * PER_PAGE, total);
          resultInfo.innerHTML = `${total.toLocaleString('ja-JP')}件中 <span class="text-ink-red">${from}〜${to}件目</span> を表示`;
        } else {
          resultInfo.textContent = '';
        }
      }

      if (!items.length) {
        itemsEl.innerHTML = '<li class="text-center text-gray-500 py-6">まだレビューがありません。</li>';
        pager.classList.add('hidden');
        return;
      }
      itemsEl.innerHTML = items.map(cardHtml).join('');
      renderPager();
      window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' });
    }

    pager?.addEventListener('click', (e) => {
      const a = e.target.closest('[data-page]');
      if (!a) return;
      e.preventDefault();
      const p = parseInt(a.dataset.page, 10);
      if (p && p !== page) { page = p; load(); }
    });

    load();
  }

  let booted = false;
  function startOnce() { if (booted) return; booted = true; boot(); }
  if (window.inkApi) startOnce();
  else { document.addEventListener('ink:api:ready', startOnce, { once: true }); window.addEventListener('load', () => setTimeout(() => { if (!window.inkApi) startOnce(); }, 1000)); }
})();
